  //load last row ordering, 
  //load favorite presets, use key name to check if favorite
  //load custom presets, filter by tool type, sort by section, add isFavorite property, push to nested array

import { PresetObj } from "../types/general-types"
import { defaultPresets } from '../assets/defaultPresets';
import { loadCustomPresets, loadFavoritePresets, loadPresetOrdering } from "./layers";

  //load default presets, filter by tool type, sort by section, add isFavorite property, push to nested array
export function buildToolPresets(toolType: string, setPresetsCallback: any, setPresetsFavoritesCallback: any) {
    let presetNestedArray: PresetObj[][] = []
    let favoritesObj: any = {}
    let favoritesArray: PresetObj[] = []
    let ordering: string[] = []
    loadPresetOrdering(toolType).then((orderByTool) => {
      ordering = JSON.parse(orderByTool)
    })
    .then(() =>loadFavoritePresets().then((favorites) => {
    favoritesObj = JSON.parse(favorites)
    })
    .then(() => loadCustomPresets().then((customPresets) => {
      if (customPresets === '') return
      let customPresetsArray: PresetObj[] = JSON.parse(customPresets)
      let filtered = customPresetsArray.filter((preset: PresetObj) => preset.type === toolType)
      let sorted = filtered.sort((a: PresetObj, b: PresetObj) => a.section.localeCompare(b.section))
      for (let i = 0; i < sorted.length; ) {
        let section = sorted[i].section;
        let sectionArray = [];
        let j = i;
        while (j < sorted.length && sorted[j].section === section) {
          if (favoritesObj[sorted[j].name]) {
            sorted[j].isFavorite = true;
            favoritesArray.push(sorted[j]);
          }
          sectionArray.push(sorted[j]);
          j++;
        }
        presetNestedArray.push(sectionArray);
        i = j;
      }
    })).then(() => {
      let inOutList = []
      let inList = []
      let outList = []
      for (let i = 0; i < defaultPresets.length; i++) {
        if(favoritesObj[defaultPresets[i].name]){
          defaultPresets[i].isFavorite = true;
          favoritesArray.push(defaultPresets[i])
        } else {
          defaultPresets[i].isFavorite = false;
        }
        if (defaultPresets[i].section == 'In/Out') {
          inOutList.push(defaultPresets[i])
        } else if (defaultPresets[i].section == 'In') {
          inList.push(defaultPresets[i])
        } else if (defaultPresets[i].section == 'Out'){
          outList.push(defaultPresets[i])
        }
      }
      presetNestedArray.push(inOutList)
      presetNestedArray.push(inList)
      presetNestedArray.push(outList)
      if (ordering.length > 0) {
        presetNestedArray.sort((a, b) => {
          let aSection = a[0].section;
          let bSection = b[0].section;
          let aIndex = ordering.indexOf(aSection);
          let bIndex = ordering.indexOf(bSection);
          if (aIndex === -1) aIndex = Number.MAX_SAFE_INTEGER;
          if (bIndex === -1) bIndex = Number.MAX_SAFE_INTEGER;
          return aIndex - bIndex;
        });
      }
      setPresetsCallback(presetNestedArray)
      setPresetsFavoritesCallback(favoritesArray)
    }))
  }